import { SpatialOption, spatialValuesInRem } from './spatialValues';

export type SpatialStackOption =
  | SpatialOption.xs
  | SpatialOption.sm
  | SpatialOption.md
  | SpatialOption.lg
  | SpatialOption.xl;
export type SpatialStack = { [option in SpatialStackOption | SpatialOption.default]: string };

/**
 * The overwhelming majority of UI is scrolled vertically. To achieve vertical rhythm, we will aim to
 * uniformly space components in a vertical structure.
 *
 * **Usage**: Applied to a `columns` component in a layout, message on a heading, to whatever is stacked.
 * `margin: spatialStack.default` // `0 0 1rem 0`
 */
export const spatialStack: SpatialStack = {
  default: `0 0 ${spatialValuesInRem.default} 0`,
  xs: `0 0 ${spatialValuesInRem.xs} 0`,
  sm: `0 0 ${spatialValuesInRem.sm} 0`,
  md: `0 0 ${spatialValuesInRem.md} 0`,
  lg: `0 0 ${spatialValuesInRem.lg} 0`,
  xl: `0 0 ${spatialValuesInRem.xl} 0`
};
